// extracted by mini-css-extract-plugin
export var FullLengthDoctorImage = "index-module--FullLengthDoctorImage--t3GFS";
export var image = "index-module--image--u6acX";
export var info = "index-module--info--GUPfk";
export var linkhover = "index-module--linkhover--+za-s";
export var location = "index-module--location--Kd8Vm";
export var name = "index-module--name--gvG31";
export var screenreader = "index-module--screenreader--H3dn0";